import { render, staticRenderFns } from "./App.vue?vue&type=template&id=a4bbe4ec"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=a4bbe4ec&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports